import React, { useState, useEffect } from 'react';
import { Users, Phone, Download } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const AdminCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const r = await axios.get(`${API}/admin/orders`);
        const map = {};
        for (const o of r.data) {
          const phone = o.customer_phone || '';
          if (!map[phone]) {
            map[phone] = { name: o.customer_name, phone, email: o.customer_email || '', city: o.city || '', orders: 0, total: 0, lastOrder: o.created_at };
          }
          map[phone].orders++;
          map[phone].total += o.total_amount || 0;
          if (o.created_at > map[phone].lastOrder) map[phone].lastOrder = o.created_at;
        }
        setCustomers(Object.values(map).sort((a, b) => b.orders - a.orders));
      } catch (e) { console.error(e); }
    };
    fetchCustomers();
  }, []);

  const filtered = customers.filter(c =>
    !search || c.name?.includes(search) || c.phone?.includes(search) || c.email?.includes(search)
  );

  const exportCSV = () => {
    const params = new URLSearchParams();
    if (dateFrom) params.set('date_from', dateFrom);
    if (dateTo) params.set('date_to', dateTo);
    const url = `${API}/admin/customers/export?${params.toString()}`;
    window.open(url, '_blank');
    toast.success('קובץ מייוצא...');
  };

  return (
    <div dir="rtl" data-testid="admin-customers-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-black text-[#2C3E2D]" style={{ fontFamily: 'Heebo, sans-serif' }}>
          <Users className="w-5 h-5 inline ml-2" />לקוחות ({customers.length})
        </h2>
        <div className="flex items-center gap-2">
          <input
            placeholder="חיפוש לקוח..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="border rounded-lg px-3 py-2 text-sm w-48"
            data-testid="customer-search"
          />
        </div>
      </div>

      {/* Export Bar */}
      <div className="bg-white rounded-xl p-3 mb-4 border border-stone-200 flex items-center gap-3 flex-wrap">
        <span className="text-sm font-bold text-stone-600">ייצוא לקוחות:</span>
        <div className="flex items-center gap-2">
          <label className="text-xs text-stone-400">מתאריך</label>
          <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} className="border rounded-lg px-2 py-1.5 text-sm" data-testid="export-date-from" />
        </div>
        <div className="flex items-center gap-2">
          <label className="text-xs text-stone-400">עד תאריך</label>
          <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} className="border rounded-lg px-2 py-1.5 text-sm" data-testid="export-date-to" />
        </div>
        <button
          onClick={exportCSV}
          className="bg-green-600 hover:bg-green-700 text-white rounded-lg px-4 py-2 text-sm font-bold flex items-center gap-1"
          data-testid="export-csv-btn"
        >
          <Download className="w-4 h-4" /> הורד CSV
        </button>
      </div>

      <div className="bg-white rounded-xl border border-stone-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 border-b">
            <tr>
              <th className="text-right px-4 py-3 font-bold text-stone-600">שם</th>
              <th className="text-right px-4 py-3 font-bold text-stone-600">טלפון</th>
              <th className="text-right px-4 py-3 font-bold text-stone-600">אימייל</th>
              <th className="text-right px-4 py-3 font-bold text-stone-600">עיר</th>
              <th className="text-center px-4 py-3 font-bold text-stone-600">הזמנות</th>
              <th className="text-right px-4 py-3 font-bold text-stone-600">סה"כ</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c, i) => (
              <tr key={i} className="border-b last:border-0 hover:bg-stone-50" data-testid={`customer-row-${i}`}>
                <td className="px-4 py-3 font-bold">{c.name}</td>
                <td className="px-4 py-3 text-stone-500" dir="ltr">{c.phone}</td>
                <td className="px-4 py-3 text-stone-400 text-xs">{c.email || '-'}</td>
                <td className="px-4 py-3 text-stone-500">{c.city || '-'}</td>
                <td className="px-4 py-3 text-center"><span className="bg-[#D97706]/10 text-[#D97706] font-bold px-2 py-0.5 rounded-full text-xs">{c.orders}</span></td>
                <td className="px-4 py-3 font-bold text-[#D97706]">₪{c.total.toLocaleString()}</td>
                <td className="px-4 py-3">
                  <a href={`whatsapp://send?phone=972${(c.phone || '').replace(/^0/, '').replace(/[-\s]/g, '')}`} target="_blank" rel="noopener noreferrer" className="text-green-500 hover:text-green-600">
                    <Phone className="w-4 h-4" />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCustomers;
